import { ReactNode } from "react";
import styles from "@/pages/index.module.css";
import { Link } from "react-router";

export function Help(): ReactNode {
  return (
    <div className={styles.helpContainer}>
      <Link to="/" className={styles.modalClose}>
        𝗫
      </Link>
      <div className={styles.helpContent}>
        <h1>Help & documentation</h1>
        <h2>About DoodlyCoo</h2>
        <p>
          DoodlyCoo is a daily drawing game. It is entirely free and does not require you to create
          an account.
        </p>
        <p>
          Each day, you are given a new prompt to draw and have three 20-second rounds to draw it.
          At the end of each round, the pigeon will guess the prompt based on your drawing. You win
          if it manages to correctly guess the prompt within the three rounds.
        </p>
        <h2>Use of site assets</h2>
        <p>
          The assets on this website, including the graphics and code, are provided for your
          entertainment. Please don’t use any part of it for commercial purposes or public display.
        </p>
        <h2>Privacy policy</h2>
        <p>
          When you create drawings, they are uploaded to the DoodlyCoo servers for image analysis to
          generate the pigeon's guess. None of these drawings are shared with others or sold for
          marketing purposes.
        </p>
        <p>
          DoodlyCoo may use Google AdSense to show ads. Google and its partners use cookies or
          similar technologies to serve ads based on your visits to this and other websites. You can
          learn more and manage your ad preferences at{" "}
          <a href="adssettings.google.com">adssettings.google.com</a>.
        </p>
        <h2>Contact</h2>
        <p>
          Have more questions? Email me at{" "}
          <a href="mailto:claire@doodly-coo.fun">claire@doodly-coo.fun</a>
        </p>
      </div>
    </div>
  );
}
